<template>
  <section id="message" class="section message">
    <div class="container">
      <div class="section-head" v-reveal>
        <span class="eyebrow">05 / Message</span>
        <h2 class="section-title">
          <span class="en">Message</span>
          代表メッセージ
        </h2>
      </div>

      <div class="message__body" v-reveal="40">
        <div class="message__prose">
          <p v-reveal="60">
            この会社を始めたのは、最後まで自分の手で見届けられる仕事をしたかったからです。要件を伺い、設計し、動かして、運用まで面倒を見る。宇都宮で少人数のまま続けてきたのは、その距離感を手放したくなかったからでした。
          </p>
          <p v-reveal="100">
            ここ数年、開発の現場は AI で大きく変わりました。以前より短い時間で形になる場面が増えました。私自身、日々の開発を AI に任せる範囲を広げ続けており、記事の執筆から公開までを自動で回す仕組みや、検証の設計に重心を置いた研究用のシステムを、自社で作って動かしています。速さは、確かに手に入ります。
          </p>
          <p v-reveal="140">
            一方で、AI が書いたコードをそのまま信じてよいわけではありません。私たちが何度も見てきたのは、テストがすべて通っているのに本番で止まる、という種類の失敗です。だから役割を分けています。速さは AI に、確かさは人の目とテストに。
          </p>
          <p v-reveal="180">
            AI を使うこと自体は目的ではありません。お客様の課題が、確かに動くかたちになり、そのあとも動き続けること。そこまでを引き受けるための道具として、技術と経験、そして AI を組み合わせています。
          </p>
          <p v-reveal="220">
            宇都宮から、顔の見えるものづくりを続けてまいります。
          </p>
          <!-- 署名は正本どおり全角スペース（U+3000）を含む -->
          <!-- eslint-disable-next-line no-irregular-whitespace -->
          <p class="message__sign" v-reveal="260">代表取締役　桧山 聡</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MessageSection',
}
</script>

<style scoped lang="scss">
.message {
  border-top: 1px solid var(--line);
}

.message__body {
  margin-top: clamp(40px, 6vw, 72px);
  padding: clamp(32px, 4vw, 64px);
  background: var(--paper-raised);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  box-shadow: 0 30px 60px -46px rgba(20, 22, 27, 0.5);
}

.message__prose {
  display: flex;
  flex-direction: column;
  gap: 26px;
  max-width: 62ch;
  margin-inline: auto;

  p {
    font-size: clamp(1rem, 1.3vw, 1.12rem);
    line-height: 1.95;
    color: var(--ink-soft);
  }
}

.message__prose .message__sign {
  margin-top: clamp(18px, 2.4vw, 30px);
  padding-top: clamp(18px, 2.4vw, 30px);
  border-top: 1px solid var(--line-soft);
  text-align: right;
  font-family: var(--font-jp);
  font-weight: 500;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
  line-height: 1.8;
  color: var(--ink);
}
</style>
